import { Button } from '@fl/cmsch-fe-library';
import React, { FC, memo } from 'react';
import { useOurTranslation } from 'app/translations';
import styles from './styles.sass';
interface Props {
  /** Optional test identifier used by automated tests. */
  testId?: string;
  /** Resets all mating forms and session state. */
  resetForms(): void;
}
const ResetAllSettingsButtonBase: FC<Props> = ({
  resetForms,
  testId
}) => {
  const {
    t
  } = useOurTranslation('mating');
  return <div className={styles.resetAllButton} data-test-id={testId} data-sentry-component="ResetAllSettingsButtonBase" data-sentry-source-file="index.tsx">
            <Button onClick={resetForms} danger data-sentry-element="Button" data-sentry-source-file="index.tsx">
                {t('resetAllSettings')}
            </Button>
        </div>;
};

/**
 * Memoized reset button for the mating screen.
 *
 * @param props Reset handler and optional test id.
 * @returns The button that clears mating settings.
 */
export const ResetAllSettingsButton = memo(ResetAllSettingsButtonBase);